import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { KycCheckReturnType } from '~/hooks/kyc';
import KycModal from './KycModal';

const setKycModalOpen = (kycCheck: KycCheckReturnType): void => {
  const div = document.createElement('div');
  document.body.appendChild(div);

  function destroy() {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  function render(props: any) {
    const { open, onClose } = props;
    /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */
    setTimeout(() => {
      ReactDOM.render(<KycModal open={open} onClose={onClose} kycCheck={kycCheck} />, div);
    });
  }

  function close() {
    render({ open: false, onClose: close });
    setTimeout(() => {
      destroy();
    }, 500);
  }

  render({ open: true, onClose: close });
};

export default setKycModalOpen;
